import React from "react";

const ReviewTab = () => {
  return (
    <div className="about-tab-wrapper">
      <div className="about-content">
        <h2>Reviews</h2>
      </div>
    </div>
  );
};

export default ReviewTab;
